import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_vBNrxygcjjdQ: {
	id: 'prd_vBNrx2DEV2ygcjjdQ'
	ident: 'prd_vBNrxygcjjdQ'
	sku: 'simple_workbook_bundle_35_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_lM2h62DEV2RNVWFil'
		amount: 64
		amount_usd: 35
		currency: 'USD'
		amount_with_discount: 35
		discount: 29
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_vBNrxygcjjdQ, OneTimeProduct>
const prd_vBNrxygcjjdQ = { ident: 'prd_vBNrxygcjjdQ' } as typeof _prd_vBNrxygcjjdQ

export default prd_vBNrxygcjjdQ
